var _g, _g2, _g3, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavJobsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "briefcase_921256",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29045",
    "data-name": "Group 29045",
    transform: "translate(0 13.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29044",
    "data-name": "Group 29044"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39870",
    "data-name": "Path 39870",
    d: "M0,90v21.759a11.875,11.875,0,0,0,11.719,12h2.344v-4.8H28.125v4.8h23.75v-4.8H65.938v4.8h2.344a11.875,11.875,0,0,0,11.719-12V90Z",
    transform: "translate(0 -90)",
    fill: "#62d648"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_29047",
    "data-name": "Group 29047",
    transform: "translate(23.041 51.041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29046",
    "data-name": "Group 29046"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39871",
    "data-name": "Path 39871",
    d: "M179.119,335.8V331H154.8v4.8H150v24.159h33.918V335.8Z",
    transform: "translate(-150 -331)",
    fill: "#62d648"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_29049",
    "data-name": "Group 29049",
    transform: "translate(0 45.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29048",
    "data-name": "Group 29048"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39872",
    "data-name": "Path 39872",
    d: "M14.4,309.13v-4.8H12a16.73,16.73,0,0,1-12-5.08v34.038H19.2V309.13Z",
    transform: "translate(0 -299.251)",
    fill: "#62d648"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_29051",
    "data-name": "Group 29051",
    transform: "translate(60.801 45.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29050",
    "data-name": "Group 29050"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39873",
    "data-name": "Path 39873",
    d: "M399.2,304.331h-2.4v4.8H392v24.159h19.2V299.251A16.73,16.73,0,0,1,399.2,304.331Z",
    transform: "translate(-392 -299.251)",
    fill: "#62d648"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_29053",
    "data-name": "Group 29053",
    transform: "translate(18.527 46.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29052",
    "data-name": "Group 29052"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3021",
    "data-name": "Rectangle 3021",
    width: 5,
    height: 5,
    fill: "#62d648"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_29055",
    "data-name": "Group 29055",
    transform: "translate(56.555 46.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29054",
    "data-name": "Group 29054"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3022",
    "data-name": "Rectangle 3022",
    width: 5,
    height: 5,
    fill: "#62d648"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_29057",
    "data-name": "Group 29057",
    transform: "translate(23.201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29056",
    "data-name": "Group 29056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39874",
    "data-name": "Path 39874",
    d: "M151,0V9.6h4.8V4.8h24V9.6h4.8V0Z",
    transform: "translate(-151)",
    fill: "#62d648"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavJobsIcon);
export default __webpack_public_path__ + "static/media/favJobs_icon.7ff1cd61d8065a9fa0e326c5d22d48f0.svg";
export { ForwardRef as ReactComponent };